// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-form--label-left .el-form-item__label {\r\n  text-align: right;\n}\n.el-button--medium {\r\n  padding: 10px 10px;\n}\n.huoqu {\r\n  width: 600px;\r\n  margin-top: 30px;\r\n  margin-left: -40px;\n}\r\n", ""]);
// Exports
module.exports = exports;
